import Icon from '../../components/Icon.vue';
Icon.register({
  'brands/dropbox': {
    width: 528,
    height: 512,
    paths: [{
      d: 'M264.4 116.3l-132 84.3 132 84.3-132 84.3-132.4-85.1 132.3-84.3-132.3-83.5 132.3-84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3zM264.4 284.1l132-84.3-132-83.6 131.3-84.2 132.3 84.3-132.3 84.3 132.3 84.2-132.3 84.3z'
    }]
  }
});